require(["dojo/query", "dojo/on", "dojo/mouse", "dojo/domReady!"], function(query, on, mouse) {
    var timeout = 600;
    var cssClass = "sfhover";
  	var elems;
    var queue = [];
    var reCSS = new RegExp("\\b" + cssClass + "\\b");
    var i, j;

 /*   if(isIpad() || isIphone()) {
    	query("#submenu li").forEach(function(node, index, nodelist){
    		on(node, "focus", function(evt){
    			queueFlush();
                this.className += " " + cssClass;
            });
    		on(node, "blur", function(evt){
    			queue.push([setTimeout(queueTimeout, timeout), this]);
            });
    		on(node, touch.press, function(e){
    			if (this.className.search(reCSS) === -1) {
                    // CSS not set, so clear all sibling (and decendants) menus, and then set CSS on this menu...
                    elems = this.parentNode.getElementsByTagName("li");
                    for (i=0; i<elems.length; i++) {
                        elems[i].className = elems[i].className.replace(reCSS, "");
                    }
                    this.className += " " + cssClass;
                } else {
                    // CSS already set, so clear all decendant menus and then this menu...
                    elems = this.getElementsByTagName("li");
                    for (j=0; j<elems.length; j++) {
                        elems[j].className = elems[j].className.replace(reCSS, "");
                    }
                    this.className = this.className.replace(reCSS, "");
                }
                if (e && e.stopPropagation){
                    e.stopPropagation();
    			} else {
                    window.event.cancelBubble = true;
    			}
            });
    	});
    } else {*/
    	query("#submenu li").forEach(function(node, index, nodelist){

    		on(node, mouse.enter, function(event){
    			queueFlush();
                this.className += " " + cssClass;
    		});
    		on(node, mouse.leave, function(event){
    			queue.push([setTimeout(queueTimeout, timeout), this]);
    		});
    		on(node, "focus", function(evt){
    			queueFlush();
                this.className += " " + cssClass;
            });
    		on(node, "blur", function(evt){
    			queue.push([setTimeout(queueTimeout, timeout), this]);
            });
    		on(node, "click", function(e){
    			if (this.className.search(reCSS) === -1) {
                    // CSS not set, so clear all sibling (and decendants) menus, and then set CSS on this menu...
                    elems = this.parentNode.getElementsByTagName("li");
                    for (i=0; i<elems.length; i++) {
                        elems[i].className = elems[i].className.replace(reCSS, "");
                    }
                    this.className += " " + cssClass;
                } else {
                    // CSS already set, so clear all decendant menus and then this menu...
                    elems = this.getElementsByTagName("li");
                    for (j=0; j<elems.length; j++) {
                        elems[j].className = elems[j].className.replace(reCSS, "");
                    }
                    this.className = this.className.replace(reCSS, "");
                }
                if (e && e.stopPropagation){
                    e.stopPropagation();
    			} else {
                    window.event.cancelBubble = true;
    			}
            });
    	});
  //  }

    window.queueFlush = function () {
        while (queue.length) {
            clearTimeout(queue[0][0]);
            queueTimeout();
        }
    }

    window.queueTimeout = function () {
        if (queue.length) {
            var el = queue.shift()[1];
            el.className = el.className.replace(reCSS, "");
        }
    }
});
